import { render } from "./App.vue?vue&type=template&id=295ee508"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/styles/Reset.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=295ee508&lang=scss"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__